import React from "react"
import PropTypes from "prop-types"
import { Space } from "antd"

import { W1 } from "@components"

const Stack = ({ children }) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={W1}>
      {children}
    </Space>
  )
}

Stack.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Stack
